import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rk-share-hint',
  template: ` <div class="hint">{{ hint }}</div> `,
  styleUrls: ['./share-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareHintComponent {
  @Input()
  hint = '';
}
